import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class Team_EN extends Component {
    render() {
        const { classes } = this.props;

        return (
            <Fragment>
                <text
                    className={ classes.root }
                    transform="translate(23.69 17.65) rotate(-34.38)"
                >
                    C
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.9, -0.44, 0.44, 0.9, 29.41, 13.75)"
                >
                    o
                </text>
                <text
                    className={ classes.root }
                    transform="translate(34.83 11.11) rotate(-18.03)"
                >
                    n
                </text>
                <text
                    className={ classes.root }
                    transform="translate(40.5 9.3) rotate(-11.25)"
                >
                    s
                </text>
                <text
                    className={ classes.root }
                    transform="translate(44.81 8.46) rotate(-5.98)"
                >
                    t
                </text>
                <text
                    className={ classes.root }
                    transform="translate(48.4 8.07) rotate(-1.18)"
                >
                    r
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(1, 0.09, -0.09, 1, 52.17, 7.92)"
                >
                    u
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.98, 0.21, -0.21, 0.98, 58.03, 8.45)"
                >
                    c
                </text>

                <text
                    className={ classes.root }
                    transform="translate(63.19 9.62) rotate(18.26)"
                >
                    t
                </text>
                <text
                    className={ classes.root }
                    transform="translate(66.66 10.78) rotate(22.36)"
                >
                    i
                </text>
                <text
                    className={ classes.root }
                    transform="translate(69.03 11.69) rotate(27.36)"
                >
                    v
                </text>
                <text
                    className={ classes.root }
                    transform="translate(73.5 13.98) rotate(34.17)"
                >
                    e
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.53, 0.85, -0.85, 0.53, 86, 25.17)"
                >
                    B
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.41, 0.91, -0.91, 0.41, 89.3, 30.41)"
                >
                    u
                </text>
                <text
                    className={ classes.root }
                    transform="translate(91.71 35.83) rotate(72.5)"
                >
                    s
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.22, 0.97, -0.97, 0.22, 92.99, 40.02)"
                >
                    i
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.13, 0.99, -0.99, 0.13, 93.65, 42.46)"
                >
                    n
                </text>
                <text
                    className={ classes.root }
                    transform="translate(94.38 48.33) rotate(89.54)"
                >
                    e
                </text>
                <text
                    className={ classes.root }
                    transform="translate(94.39 53.7) rotate(96.25)"
                >
                    s
                </text>
                <text
                    className={ classes.root }
                    transform="translate(93.92 58.05) rotate(101.99)"
                >
                    s
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(-0.29, 0.96, -0.96, -0.29, 92.97, 62.35)"
                >
                    l
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(-0.35, 0.94, -0.94, -0.35, 92.19, 64.97)"
                >
                    i
                </text>
                <text
                    className={ classes.root }
                    transform="translate(91.38 67.38) rotate(115.42)"
                >
                    k
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(-0.53, 0.85, -0.85, -0.53, 89.14, 72.12)"
                >
                    e
                </text>
                <text
                    className={ classes.root }
                    transform="translate(12.52 70.4) rotate(-112.09)"
                >
                    P
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(-0.25, -0.97, 0.97, -0.25, 10.29, 64.9)"
                >
                    e
                </text>
                <text
                    className={ classes.root }
                    transform="translate(8.96 59.7) rotate(-98.64)"
                >
                    r
                </text>
                <text
                    className={ classes.root }
                    transform="translate(8.38 55.95) rotate(-93.31)"
                >
                    s
                </text>
                <text
                    className={ classes.root }
                    transform="translate(8.06 51.62) rotate(-86.6)"
                >
                    o
                </text>
                <text
                    className={ classes.root }
                    transform="translate(8.41 45.58) rotate(-78.78)"
                >
                    n
                </text>

                <text
                    className={ classes.root }
                    transform="translate(9.58 39.78) rotate(-71.48)"
                >
                    a
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(0.4, -0.92, 0.92, 0.4, 11.28, 34.85)"
                >
                    l
                </text>
                <text
                    className={ classes.root }
                    transform="translate(33.73 96.74) rotate(17.06)"
                >
                    C
                </text>
                <text
                    className={ classes.root }
                    transform="translate(41.09 98.85) rotate(9.81)"
                >
                    r
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(1, 0.1, -0.1, 1, 45.27, 99.54)"
                >
                    i
                </text>
                <text
                    className={ classes.root }
                    transform="matrix(1, 0.02, -0.02, 1, 48.24, 99.84)"
                >
                    t
                </text>
                <text
                    className={ classes.root }
                    transform="translate(52.29 99.9) rotate(-2.75)"
                >
                    i
                </text>
                <text
                    className={ classes.root }
                    transform="translate(55.35 99.8) rotate(-8.01)"
                >
                    c
                </text>
                <text
                    className={ classes.root }
                    transform="translate(61.23 98.94) rotate(-15.05)"
                >
                    a
                </text>
                <text
                    className={ classes.root }
                    transform="translate(66.73 97.38) rotate(-20.42)"
                >
                    l
                </text>
            </Fragment>
        );
    }
}
export default Team_EN;

Team_EN.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string
    })
};

Team_EN.defaultProps = {
    classes: {}
};
